module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture30-c9cee30d0d07cf3f1a70d4de51bdd182.jpg";